export default "__VITE_ASSET__DIEt$gg6__"